export default __webpack_public_path__ + "img/fCPoeYsZ.f2b4df80.svg";